import { render, staticRenderFns } from "./inclus.vue?vue&type=template&id=0254e9a8&scoped=true"
import script from "./inclus.vue?vue&type=script&lang=js"
export * from "./inclus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0254e9a8",
  null
  
)

export default component.exports